export enum TipoOperacionEnum {
  Agua = 'AGUA',
  Energia = 'ENERGIA'
}